module.exports = __webpack_public_path__ + "img/cn-stu-1-t.de719c11.png";